export default "__VITE_ASSET__0674bae3__"